import type { Msg, Session } from '@/store/client';
import { isSessionCategory, SessionCategoryPrefix } from '@/store/client';
import { useUserInfo } from '@/scripts/hooks';

export interface MsgTransferPreviewContentProps {
  session: Session;
  message: Msg;
}

export const MsgTransferPreviewContent = memo(function MsgTransferPreviewContent({
  session,
  message,
}: MsgTransferPreviewContentProps) {
  const { t } = useTranslation();
  const { amount, symbol, sendTo } = message.payload;

  const { user: toUser } = useUserInfo(sendTo);

  const isGroup = useMemo(() => {
    return isSessionCategory(session.chat_id, SessionCategoryPrefix.Group);
  }, [session]);

  if (isGroup)
    return `[${t('chat.transferText')}] ${amount} ${symbol} ${t('chat.toUserText', { name: toUser?.name })}`;
  return `[${t('chat.transferText')}] ${amount} ${symbol}`;
});
